import { render } from "./ItemSalesByPriceReport.vue?vue&type=template&id=3d6edd4d&scoped=true"
import script from "./ItemSalesByPriceReport.vue?vue&type=script&lang=js"
export * from "./ItemSalesByPriceReport.vue?vue&type=script&lang=js"

import "./ItemSalesByPriceReport.vue?vue&type=style&index=0&id=3d6edd4d&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6edd4d"]])

export default __exports__